import script from "./tupian.vue?vue&type=script&setup=true&lang=js"
export * from "./tupian.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__